<template>
  <el-dialog
    append-to-body
    width="400px"
    title="上传发票"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    center
  >
    <el-form
      ref="elFormDomUploadDialog"
      label-width="auto"
      label-position="left"
      :model="form.data"
      :rules="form.rules"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="上传发票:" prop="image">
            <el-upload
              class="upload-demo"
              :limit="1"
              action="/api/common/qiniu/uploadFile"
              :headers="{ token: token }"
              :on-exceed="handleExceed"
              :on-success="handleAvatarSuccess"
              :on-remove="handleRemove"
              ref="uploadInvoiceDom"
              :file-list="form.data.fileList"
              accept="image/jpeg, image/png, image/gif, .pdf, .xlsx, .xls "
            >
              <el-button type="primary" plain>添加附件</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button
          v-loading="btnLoading"
          :disabled="btnLoading"
          type="primary"
          @click="conFirm"
          >确定</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>
<script>
import { getStorage } from "@/storage";
export default {
  name: "handleRefundDialog",
  data() {
    return {
      token: getStorage("token"),
      visible: false,
      form: {
        data: {
          image: [],
          fileList: [],
        },
        rules: {
          image: [
            { required: true, message: "请上传发票凭证", trigger: "change" },
          ],
        },
      },
      btnLoading: false,
      info: null,
    };
  },
  methods: {
    getDetail(row) {
      this.info = row;
      console.log(this.info, "info");
    },
    reset(done) {
      this.form.data.image = [];
      this.form.data.fileList = [];
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    handleAvatarSuccess(event) {
      if (event.code == 1) {
        let list = this.$refs.uploadInvoiceDom.uploadFiles;
        let urlListSuccess = list.filter((i) => i.status == "success");
        let yetList = urlListSuccess.map((item) => item.response);
        this.form.data.image = yetList.map((item) => {
          return {
            url: item.data.all_path_url,
            name: item.data.name,
          };
        });
        this.$refs.elFormDomUploadDialog.clearValidate(["image"]); // 清除 username 字段的校验状态，但不重置值
      } else {
        this.$message({
          type: "error",
          message: event.msg,
        });
      }
    },
    // 移除图片
    handleRemove(file, fileList) {
      let list = this.$refs.uploadInvoiceDom.uploadFiles;
      let urlListSuccess = list.filter((i) => i.status == "success");
      let yetList = urlListSuccess.map((item) => item.response);
      this.form.data.image = yetList.map((item) => {
        return {
          url: item.data.all_path_url,
          name: item.data.name,
        };
      });
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制最多只能选择 1 个文件`);
    },
    conFirm() {
      this.$refs.elFormDomUploadDialog.validate((valid) => {
        if (valid) {
          let imgStr = this.form.data.image.map((item) => item.url).join(",");
          let params = {
            id: this.info.id,
            type: this.info.type,
            invoice_file: imgStr,
          };
          this.$http.post("/admin/invoice/upload", params).then((res) => {
            if (res.code == 1) {
              this.$message({
                type: "success",
                message: "上传成功！",
              });
              this.toggle(false);
              this.$emit("update");
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  overflow: auto;
}
::v-deep {
  .my-label {
    color: red !important;
  }
}
</style>
